module.exports = __webpack_public_path__ + "static/media/service-img.55e941e0.jpg";